angular.module('core')
  .service('highchartConfigs', ['$filter', function($filter) {
    var publics = {};

    publics.labelStyle = {
      'font-size': '16px',
      'font-family': '\'Proxima Nova Condensed\', Arial, sans-serif',
      'font-weight': '500'
    };

    publics.getYAxisLabelFormatter = function(labelInfo, labelFilter) {
      if (labelInfo.isFirst || labelInfo.isLast) {
        return labelInfo.value + ' ' + labelFilter;
      }
      else {
        return '';
      }
    };

    publics.getYAxisLabelFormatterPrint = function(labelInfo, labelFilter) {
      if (labelInfo.isFirst || labelInfo.isLast) {
        return labelInfo.value + ' ' + labelFilter;
      }
      else {
        return labelInfo.value;
      }
    };

    publics.getXAxisLabelFormatter = function(type) {
      return function() {
        if (this.isFirst || this.isLast) {
          return this.value + ' ' + type;
        }
      };
    };

    publics.getYAxisStackLabels = function() {
      return {
        enabled: true
      };
    };

    publics.plotOptions = {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false
        },
        states: {
          hover: {
            enabled: false
          }
        }
      }
    };

    publics.title = {
      text: ''
    };
    
    return publics;

  }]);
